import Vue from 'vue';
import App from './App.vue';
// import AppInner from './Layouts/AppInner.vue';
import { router } from './router';
import store from './store';
import Slider from '@jeremyhamm/vue-slider';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import loader from 'vue-ui-preloader';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios'
import Print from 'vue-print-nb' // this npm for print any section in HTML page 
 
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faInfo,
  faLock,
  faEnvelope,
  faPhoneAlt,
  faTransgender,
  faCalendar,
  faIdCard,
  faAddressBook,
  
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';


library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt,  faInfo, faLock, faEnvelope, faPhoneAlt, faTransgender, faCalendar, faIdCard,faAddressBook);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(require('vue-moment'));

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(loader);
Vue.use(Slider);
Vue.use(Print);
// Vue.use(Layouts);
Vue.prototype.$axios = axios


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// to force Update

Vue.forceUpdate;

new Vue({
  router,
  store,
  // AppInner,
  render: h => h(App)
}).$mount('#app');
